import { render, staticRenderFns } from "./ExternalPaymentCallbackView.vue?vue&type=template&id=1bbca4f7&"
import script from "./ExternalPaymentCallbackView.vue?vue&type=script&lang=ts&"
export * from "./ExternalPaymentCallbackView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports